import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js';
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Myringotomy with Grommet in Delhi, India | Treatment, Cost & Doctors</title>
            <meta name="description" content="Get safe Myringotomy with Grommet in Delhi. Learn about Myringotomy and Grommet Insertion, treatment, procedure, recovery, and cost at MedFirst ENT Centre." />
            <meta name="keywords" content="Myringotomy with Grommet,   Myringotomy and Grommet Insertion, Grommet insertion surgery, Myringotomy with grommet insertion cost, Myringotomy and grommet insertion procedure" />
            <link rel="canonical" href="https://entdelhi.com/myringotomy-with-grommet/" />
            <meta property="og:title" content="Myringotomy with Grommet in Delhi, India | Treatment, Cost & Doctors" />
            <meta property="og:description" content="Get safe Myringotomy with Grommet in Delhi. Learn about Myringotomy and Grommet Insertion, treatment, procedure, recovery, and cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages/>
        
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        <GetInTouch />
      </main>
    </div>
  );
}
